// extracted by mini-css-extract-plugin
export default {"menu-select-item":"EFSelect_menu-select-item__SeOoJ","dark":"EFSelect_dark__4pgBg","select-chip":"EFSelect_select-chip__44z3K","select-field":"EFSelect_select-field__wXzTJ"};